import { render } from "./ProspectNews.vue?vue&type=template&id=7cbca548"
import script from "./ProspectNews.vue?vue&type=script&lang=js"
export * from "./ProspectNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__